import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { configService } from '../services/configService';
import { AppConfig } from '@/types/config';

export const useConfigs = () => {
    const queryClient = useQueryClient();

    const { data: configs, isLoading } = useQuery({
        queryKey: ['configs'],
        queryFn: configService.getConfigs
    });

    const updateConfig = useMutation({
        mutationFn: ({ configs }: { configs: AppConfig }) =>
            configService.updateConfig(configs),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['configs'] });
        },
    });

    const createConfig = useMutation({
        mutationFn: ({ name, data }: { name: string; data: any }) =>
            configService.createConfig(name, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['configs'] });
        },
    });

    return {
        configs,
        isLoading,
        updateConfig,
        createConfig,
    };
}; 